<template>
  <div>
    <div v-if="layout === 'vertical'">
      <label v-if="label" :class="labelClass">
        {{ label }}
      </label>

      <textarea
        :id="id"
        :rows="rows"
        :placeholder="placeholder"
        :type="type"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        @change="onChange"
        :value="value"
        :disabled="disabled"
        class="form-control"
        :class="[
          {
            'is-invalid': !isValid,
            'is-valid': isValid && value,
          },
          inputClass,
        ]"
      ></textarea>
    </div>

    <div v-if="layout === 'horizontal'" class="row">
      <label v-if="label" class="col-md-2 col-form-label" :class="labelClass">
        {{ label }}
      </label>

      <div class="col-md-10">
        <textarea
          :rows="rows"
          :placeholder="placeholder"
          :type="type"
          @input="onInput"
          @blur="onBlur"
          @focus="onFocus"
          @change="onChange"
          :value="value"
          class="form-control"
          :class="[
            {
              'is-invalid': !isValid,
              'is-valid': isValid && value,
            },
            inputClass,
          ]"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false,
    },
    layout: {
      type: String,
      required: false,
      default: "vertical",
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    inputClass: {
      type: String,
      required: false,
    },
    labelClass: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: "text",
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    isValid: {
      type: Boolean,
      required: false,
    },
    rows: {
      type: Number,
      required: false,
    },
  },
  methods: {
    onInput(event) {
      // Can add validation here
      this.$emit("input", event.target.value);
    },
    onChange(event) {
      // Supports .lazy
      // Can add validation here
      this.$emit("change", event.target.value);
    },
    onBlur(event) {
      // Can add validation here
      this.$emit("blur", event.target);
    },
    onFocus(event) {
      // Can add validation here
      this.$emit("focus", event.target);
    },
  },
};
</script>

<style></style>
